import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Actionbutton } from "src/app/shared/common/Actionbutton";
import { CommonService } from "src/app/shared/services/common.service";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import { UserRoutingModule } from "../user-routing/user-routing.module";
import { constants } from "src/app/shared/common/contants";
import { RequirementsLibraryPopUpComponent } from "./requirements-library-pop-up/requirements-library-pop-up.component";
import { JSIGNALBUTTON } from "src/app/shared/common/JsignalButtons";

@Component({
  selector: "app-requirements-library",
  templateUrl: "./requirements-library.component.html",
  styleUrl: "./requirements-library.component.scss",
  standalone: false,
})
export class RequirementsLibraryComponent implements OnInit {
  components: any;
  backgroundColorButton: string;
  backgroundColorScreen: string;
  gridAPI;

  lastPage;

  currentPage;

  nextPage;

  nextPagePlusOne;

  totalPages;

  gridColumnAPI;

  columnDefs;

  rowClassRules;

  defaultColDef;

  rowSelection;

  paginationPageSize;

  paginationNumberFormatter;

  pageSize;
  getRowStyle: (params: any) => { backgroundColor: string };
  gridOptions: { rowHeight: number };
  workspaceId: number;
  rowData: any;

  constructor(
    private dialog: MatDialog,
    private commonService: CommonService,
    private localStorage: LocalStorageSettingsService,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private userRoutingModule: UserRoutingModule,
    private jsignalsService: JsignalService,
    private constants: constants,
  ) {
    this.components = {
      jsignalButton: JSIGNALBUTTON,
    };
  }

  ngOnInit() {
    this.backgroundColorButton = this.localStorage.getSettings("ColorA");
    this.backgroundColorScreen = this.localStorage.getSettings("ColorD");
    this.workspaceId = Number(this.localStorage.getSettings("WorkspaceId"));
    this.intializeGrid();
    this.getRequirementLibraries();
  }

  intializeGrid() {
    this.columnDefs = [
      {
        headerName: "Title",
        field: "title",
        width: 300,
        ...this.jsignalsService.autoTooltip("Title"),
      },
      {
        headerName: "System Name",
        field: "systemName",
        width: 200,
        ...this.jsignalsService.autoTooltip("System Name"),
      },
      {
        headerName: "Release Name",
        field: "releaseName",
        width: 250,
        ...this.jsignalsService.autoTooltip("Release Name"),
      },
      {
        headerName: "Module Name",
        field: "moduleNames",
        width: 180,
        ...this.jsignalsService.autoTooltip("Module Name"),
      },
      {
        headerName: "Risk Rating",
        field: "riskRatingValue",
        width: 180,
        ...this.jsignalsService.autoTooltip("Risk Rating"),
      },
      {
        headerName: "Requirement Classification",
        field: "requirementClassificationNames",
        width: 180,
        ...this.jsignalsService.autoTooltip("Requirement Classification"),
      },
      {
        headerName: "Severity",
        field: "severityName",
        width: 180,
        ...this.jsignalsService.autoTooltip("Severity"),
      },
      {
        headerName: "Probability",
        field: "probabilityName",
        width: 180,
        ...this.jsignalsService.autoTooltip("Probability"),
      },
      {
        headerName: "Detectability",
        field: "detectabilityName",
        width: 180,
        ...this.jsignalsService.autoTooltip("Detectability"),
      },
      {
        headerName: "Requirement Number",
        field: "requirementNumber",
        width: 300,
        ...this.jsignalsService.autoTooltip("Requirement Number"),
      },
      {
        headerName: "Description",
        field: "description",
        width: 300,
        ...this.jsignalsService.autoTooltip("Description"),
      },
      {
        headerName: "Status",
        field: "status",
        width: 120,
        ...this.jsignalsService.autoTooltip("Status"),
      },
      // {
      //   headerName: "Created By",
      //   field: "createdBy",
      //   width: 180,
      //   ...this.jsignalsService.autoTooltip("Created By"),
      // },
      // {
      //   headerName: "Created At",
      //   field: "createdDate",
      //   width: 180,
      //   ...this.jsignalsService.autoTooltip("Created At"),
      // },
      // {
      //   headerName: "Last Modified By",
      //   field: "lastModifiedBy",
      //   width: 180,

      //   ...this.jsignalsService.autoTooltip("Last Modified By"),
      // },
      // {
      //   headerName: "Last Modified Date",
      //   field: "lastModifiedDate",
      //   width: 180,

      //   ...this.jsignalsService.autoTooltip("Last Modified Date"),
      // },
      {
        headerName: "Action",
        filter: false,

        width: 180,
        cellRenderer: "jsignalButton",
        pinned: "left",
        lockPinned: true,
        cellRendererParams: (params: any) => ({
          edit: this.EditIcon.bind(this),
          delete: this.deleteIcon.bind(this),
        }),
      },
    ];

    this.defaultColDef = {
      filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: "OR",
      },
      sortable: true,
      filter: true,
      resizable: true,
    };

    this.gridOptions = {
      rowHeight: 40,
    };

    // if the record has status==no , row color will change
    this.rowClassRules = {
      sick: function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },
    };
    this.getRowStyle = (params: any) => {
      console.log(params);
      console.log(params.data?.status);
      if (params.data?.status === "No") {
        return { backgroundColor: "rgb(211, 211, 211)" }; // Inline style for deleted rows
      }
      // return { backgroundColor: 'white', color: 'black' }; // Default style for other rows
    };
  }

  getRequirementLibraries() {
    this.spinner.start();

    this.commonService.getRequirementLibraries(this.workspaceId).subscribe({
      next: (response: any) => {
        if (response.error == true) {
          this.snackBar.open(response.statusMessage, "Ok", { duration: 3000 });
          this.spinner.stop();
          return;
        }
       this.rowData =
        typeof response.data === 'string'
          ? JSON.parse(response.data)
          : response.data;
        this.spinner.stop();
      },
      error: () => {
        this.spinner.stop();
      },
    });
  }

  onCreate() {
    const dialogRef = this.dialog.open(RequirementsLibraryPopUpComponent, {
      panelClass: "custom-dialog-container-materialFulfilment",
      width: "85%",
      autoFocus: false,
      disableClose: true,
      data: null, // null for Add, row object for Edit
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        console.error("No result recevied in parent");
        return;
      }

      if (result.action === "save") {
        console.log(result.data);
          this.spinner.start();
        // Call create API
        this.commonService.createRequirementLibrary(result.data).subscribe({
          next: (res: any) => {
            if (res.error == true) 
              {
              this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
              this.spinner.stop();
              return;
            }
            this.snackBar.open(res.statusMessage, "Ok", {
              duration: 3000,
            });

            this.getRequirementLibraries();
          },
          error: () => {},
        });
      }
    });
  }

  EditIcon(params: any) {
    console.log("Edit data", params.rowData);

    if (params.rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "Ok", {
        duration: 3000,
      });
      return;
    }

    const dialogRef = this.dialog.open(RequirementsLibraryPopUpComponent, {
      panelClass: "custom-dialog-container-materialFulfilment",
      width: "85%",
      autoFocus: false,
      disableClose: true,
      data: params.rowData, // null for Add, row object for Edit
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (!result) {
        console.error("No result recevied in parent");
        return;
      }

      if (result.action === "update") {
        console.log(result.data);
        this.spinner.start();
        // Call update API
        this.commonService
          .updateRequirementLibrary(params.rowData.id, result.data)
          .subscribe({
            next: (res: any) => {
              if (res.error == true) {
                this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
                this.spinner.stop();
                return;
              }
              this.snackBar.open(res.statusMessage, "Ok", {
                duration: 3000,
              });

              this.getRequirementLibraries();
            },
            error: () => {},
          });
      }
    });
  }

  deleteIcon(params: any) {
    console.log("Delete Data", params.rowData);

    if (params.rowData.status === "No") {
      this.snackBar.open(this.constants.deleterowMsg, "Ok", {
        duration: 3000,
      });
      return;
    }
    const confirmed = window.confirm(
    "Are you sure you want to delete this record?"
  );

  if (!confirmed) {
    return; // User clicked Cancel
  }
  this.spinner.start();
    this.commonService
      .updateRequirementLibraryStatus(params.rowData.id, "No")
      .subscribe({
        next: (res: any) => {
          if (res.error == true) {
            this.snackBar.open(res.statusMessage, "Ok", { duration: 3000 });
            this.spinner.stop();
            return;
          }
          this.snackBar.open(res.statusMessage, "Ok", {
            duration: 3000,
          });
this.spinner.stop();
          this.getRequirementLibraries();
        },
      });
  }

  onRefresh() {
    this.getRequirementLibraries();
  }

  onDownload() {
    this.gridAPI.exportDataAsCsv();
  }

  // pagination controls

  onPaginationChangedReturn() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();
      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;
      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;
      this.nextPagePlusOne =
        this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;
      this.totalPages = this.gridAPI.paginationGetTotalPages();
    }
  }

  //excel export function
  onBtExport() {
    this.gridAPI.exportDataAsCsv();
  }

  //pagination code
  onPaginationChanged() {
    if (this.gridAPI) {
      this.lastPage = this.gridAPI.paginationIsLastPageFound();

      this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;

      this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;

      this.nextPagePlusOne =
        this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;

      this.totalPages = this.gridAPI.paginationGetTotalPages();
    }
  }

  //this function is for going to the given page number
  onSearchChange(searchValue: number) {
    this.gridAPI.paginationGoToPage(searchValue - 1);
  }

  // below function is for changing the no of rows per page
  onPageSizeChanged(newPageSize) {
    var value = this.pageSize;

    this.gridAPI.setGridOption("paginationPageSize", Number(value));
  }

  // below function is for going to next page
  onBtNext() {
    this.gridAPI.paginationGoToNextPage();
  }

  // below function for going to previous page
  onBtPrevious() {
    this.gridAPI.paginationGoToPreviousPage();
  }

  // below function for going to first page
  onBtFirst() {
    this.gridAPI.paginationGoToFirstPage();
  }

  // below function for going to last page
  onBtLast() {
    this.gridAPI.paginationGoToLastPage();
  }

  //pagination code ends 
  

  // below function is to load the ag grid
  onGridReady(params) {
    this.gridAPI = params.api;

    this.gridColumnAPI = params.columnApi;
  }
}